<c-container class="mt-5">

  <h2>Winner Payouts</h2>

  @if (isCrossGame) {
    <app-choose-your-game [message]="'Choose a game to view its winner payouts'"
                          (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>
  }

  @if (game) {
    <app-winner-payouts [gameSetter]="{ gameP: game, isCrossGame: isCrossGame }"></app-winner-payouts>
  }

</c-container>
